export const CopyMove = 'copyMove'
